// extracted by mini-css-extract-plugin
export var defaultWrapper = "_mu-3";
export var downloadButton = "_mu-4";
export var fileContainer = "_mu-9 _mu-7";
export var fileContainerBase = "_mu-7";
export var fileContainerFixedHeight = "_mu-8 _mu-7";
export var fileInfo = "_mu-5";
export var fileInfoWidthRestricted = "_mu-6";
export var fileType = "_mu-1";
export var fileTypeName = "_mu-2";
export var image = "_mu-0";
export var link = "_mu-b";
export var overflowEllipsis = "_mu-a";